<template>
  <div class="contact">
    <div class="content">
      <p>Contact：support@aimrright.com</p>
      <!-- <p>Postcode: 189352</p> -->
      <!-- <p>Phone: +65 87499389</p> -->
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="less" scoped>
  .contact{
    height: 100%;
    display: flex;
    justify-content: center;
    padding-top: 1rem;
    // align-items: center;
    .content{
      font-weight: bold;
      padding: .12rem;
    }
  }
</style>
